// src/components/GameNameStyles.js

export function cosmeticAssetSrc(value) {
  const src = String(value || "").trim();

  if (!src) return null;

  if (
    src.startsWith("/") ||
    src.startsWith("http://") ||
    src.startsWith("https://") ||
    src.startsWith("data:")
  ) {
    return src;
  }

  return `/name-cosmetics/${src}`;
}

function ensureNameStyleAnimation() {
  if (typeof document === "undefined") return;

  const STYLE_ID = "taptopia-name-style-animation";

  if (document.getElementById(STYLE_ID)) return;

  const style = document.createElement("style");
  style.id = STYLE_ID;

  style.textContent = `
    @keyframes taptopiaNameShine {
      0% {
        background-position: 200% 50%;
      }

      100% {
        background-position: -200% 50%;
      }
    }

    @-webkit-keyframes taptopiaNameShine {
      0% {
        background-position: 200% 50%;
      }

      100% {
        background-position: -200% 50%;
      }
    }
  `;

  document.head.appendChild(style);
}

export function getNameStyleCSS(styleValue) {
  const value = String(styleValue || "").trim().toLowerCase();

  const gradients = {
  gold:
  "linear-gradient(90deg, #d99320 0%, #e8aa2e 28%, #f5c84a 42%, #fff2a0 50%, #f5c84a 58%, #e8aa2e 72%, #d99320 100%)",

golden:
  "linear-gradient(90deg, #fff2a8, #ffcc33, #ff8c00)",

ice:
  "linear-gradient(90deg, #aeb5c0 0%, #c4cad3 30%, #e7eaee 44%, #ffffff 50%, #e7eaee 56%, #c4cad3 70%, #aeb5c0 100%)",

    frost: "linear-gradient(90deg, #ffffff, #8eeaff, #2f8cff)",

    toxic: "linear-gradient(90deg, #dfff7a, #47ff5a, #00b341)",
    green: "linear-gradient(90deg, #dfff7a, #47ff5a, #00b341)",

    fire: "linear-gradient(90deg, #fff06a, #ff7a18, #ff1e1e)",
    flame: "linear-gradient(90deg, #fff06a, #ff7a18, #ff1e1e)",

    shadow: "linear-gradient(90deg, #d9d2ff, #8b5cff, #2d145c)",
    dark: "linear-gradient(90deg, #d9d2ff, #8b5cff, #2d145c)",
  };

  const backgroundImage = gradients[value];

  if (!backgroundImage) return {};

  const animated = value === "gold" || value === "ice";

  if (animated) {
    ensureNameStyleAnimation();
  }

  return {
    backgroundImage,

    WebkitBackgroundClip: "text",
    backgroundClip: "text",

    color: "transparent",
    WebkitTextFillColor: "transparent",

    // BOLD
    fontWeight: 900,

    ...(animated
      ? {
          backgroundSize: "300% 100%",
          backgroundRepeat: "repeat-x",

          WebkitTextStroke: "0.5px #111",
          paintOrder: "stroke fill",

          animationName: "taptopiaNameShine",
          animationDuration: "15s",
          animationTimingFunction: "linear",
          animationIterationCount: "infinite",

          WebkitAnimationName: "taptopiaNameShine",
          WebkitAnimationDuration: "15s",
          WebkitAnimationTimingFunction: "linear",
          WebkitAnimationIterationCount: "infinite",
        }
      : {}),
  };
}

export function getUserNameCosmetics(user) {
  return {
    bannerSrc: cosmeticAssetSrc(
      user?.active_name_banner ??
        user?.activeNameBanner ??
        user?.name_banner ??
        user?.nameBanner
    ),

    emojiSrc: cosmeticAssetSrc(
      user?.active_name_emogy ??
        user?.activeNameEmogy ??
        user?.active_name_emoji ??
        user?.activeNameEmoji ??
        user?.name_emogy ??
        user?.nameEmoji
    ),

    nameStyle: getNameStyleCSS(
      user?.active_name_style ??
        user?.activeNameStyle ??
        user?.name_style ??
        user?.nameStyle
    ),
  };
}

export function getUserBannerStyle(user, options = {}) {
  const {
    overlay = "linear-gradient(rgba(0,0,0,0.26), rgba(0,0,0,0.26))",
    fallbackImage = 'url("/v2/bg_style_1.png")',
    fallbackSize = "150%",
  } = options;

  const { bannerSrc } = getUserNameCosmetics(user);

  if (!bannerSrc) {
    return {
      backgroundImage: fallbackImage,
      backgroundRepeat: "no-repeat",
      backgroundSize: fallbackSize,
      backgroundPosition: "center",
    };
  }

  return {
    backgroundImage: `${overlay}, url('${bannerSrc}')`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
  };
}